import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type Survey from 'modules/surveys/store/models/v2/Survey'

interface StopSurveyModalProps {
  survey: Survey
  onClose: () => void
}

const StopSurveyModal = ({ survey, onClose }: StopSurveyModalProps) => {
  const { running, performAction: stopSurvey } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await survey.stopSurvey()
      survey.fetch()

      track(trackingEvents.surveys.createSurveyCancel, {
        survey_status: survey.attributes.status,
        survey_source: survey.attributes.source,
      })

      closePortal()
    },
    {
      successMessage: i18n.t('common.saved_successfully'),
    }
  )

  return (
    <Modal
      illustration="calendar-clock"
      title={i18n.t('surveys.form.stop.modal.title')}
      description={i18n.t('surveys.form.stop.modal.description')}
      onClose={onClose}
      onSubmit={stopSurvey}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    />
  )
}

export default observer(StopSurveyModal)
